const APPLICATIONS_SUPPORT_EMAIL = 'rentalapplications@zillow.com';

export { APPLICATIONS_SUPPORT_EMAIL };
